import * as React from 'react';
import {useEffect, useState} from "react";
import {Action, APP_LANDING, APP_LOGIN_PATH} from "../../types";
import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";
import {currentSession} from "../../Auth";
import {getUserProfile} from "../../api";

const ActivationRequired: React.FunctionComponent = () => {

    let [actions, setActions] = useState<Action[]>([]);
    let [doRedirectToLanding, setDoRedirectToLanding] = useState(false);
    let [doRedirectToLogin, setDoRedirectToLogin] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const fullPath = location.pathname;

    useEffect(() => {
        currentSession().then(session => {
        }).catch(e => {
            setDoRedirectToLogin(true);
        })
    }, [fullPath, history]);

    useEffect(() => {
        if (doRedirectToLanding) {
            history.push({
                pathname: APP_LANDING
            });
        }
    }, [doRedirectToLanding, history]);

    useEffect(() => {
        if (doRedirectToLogin) {
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    }, [doRedirectToLogin, history]);

    useEffect(() => {
        getUserProfile()
            .then(user => {
                if (user.actions && user.actions?.length > 0) {
                    setActions(user.actions);
                } else {
                    setDoRedirectToLanding(true);
                }
            })
            .catch(e => console.log(e));
    }, [])


    return ((!actions) ? <>Loading...</> : <>
        <div className={"container mt-3 text-center"}>
            <div className={"row justify-content-md-center"}>
                <div className={"col-lg-4 mb-3"}>
                    <h1 className="h3 mb-3 font-weight-normal">This account requires activation.</h1>
                    <p>Contact your account administrator StackLeader Inc. at contact@stackleader.com.</p>
                </div>
            </div>


        </div>
    </>);
};

export default ActivationRequired;